var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeShipMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FA0",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23L15.2 21.778C15.2 21.778 16 15.667 16 10.778C16 5.888 12 1 12 1C12 1 8 5.889 8 10.778C8 15.667 8.8 21.778 8.8 21.778L12 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F2B35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.281 21.058C14.476 19.418 15.001 14.671 15.001 10.778C15.001 7.59801 13.104 4.33201 12.001 2.69901C10.895 4.33201 9.001 7.59901 9.001 10.777C9.001 14.671 9.523 19.418 9.719 21.058L12 21.93L14.281 21.058V21.058ZM12.001 1.33514e-05C12.149 0.000183867 12.2951 0.0331925 12.4287 0.0966568C12.5624 0.160121 12.6803 0.25246 12.774 0.367014C12.946 0.578014 17 5.59201 17 10.777C17 15.675 16.224 21.655 16.191 21.908C16.1677 22.0869 16.0964 22.2561 15.9845 22.3977C15.8727 22.5393 15.7246 22.6479 15.556 22.712L12.356 23.934C12.1265 24.022 11.8725 24.022 11.643 23.934L8.443 22.712C8.099 22.582 7.855 22.272 7.808 21.908C7.775 21.655 7 15.675 7 10.778C7 5.59201 11.053 0.578013 11.225 0.368013C11.319 0.253229 11.4372 0.160695 11.5712 0.097065C11.7052 0.0334347 11.8517 0.000289194 12 1.33514e-05H12.001Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeShipMapPin);
export default __webpack_public_path__ + "static/media/orange-ship-map-pin.60bcc93e6b24d2935ab3c2f19f067791.svg";
export { ForwardRef as ReactComponent };